/* eslint-disable jsx-a11y/anchor-is-valid */
import {
    DocumentContainer,
    DocumentTable,
    Header,
    TableContainer,
} from './styles'
import {} from 'react-icons'
import { FiAlertCircle } from 'react-icons/fi'
import { MdOutlineFileUpload } from 'react-icons/md'
import { CgFileDocument } from 'react-icons/cg'

import { DocumentsModal } from '../../components/DocumentsModal'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { IdentificationDocument } from './Form/identification-document'
import { SelfieWithDocument } from './Form/selfie-with-document'
import { CNPJCard } from './Form/cnpj-card'
import { fakerAPI } from '../../utils/faker-api'
import toast from 'react-hot-toast'
import { SocialContract } from './Form/social-contract'
import { AddressProof } from './Form/address-proof'
import api from '../../services/axios'
import { useSelector } from 'react-redux'
import { StoreState } from '../../store'
import { DocumentsType } from './Form/interface'
import { get } from 'lodash'
import { Document } from './interface'

const Documentos = () => {
    const { cnpj_cpf } = useSelector((state: StoreState) => state.auth.user)

    const [isDocIdOpen, setIsDocIdOpen] = useState(false)
    const [isSelfieOpen, setIsSelfieOpen] = useState(false)
    const [isCNPJCardOpen, setIsCNPJCardOpen] = useState(false)
    const [isSocialContractOpen, setIsSocialContractOpen] = useState(false)
    const [isAddressProofOpen, setIsAddressProofOpen] = useState(false)
    const [documents, setDocuments] = useState<Document[]>([])
    const [isLoading, setIsLoading] = useState(false)

    const getDocuments = useCallback(async () => {
        try {
            setIsLoading(true)
            const { data } = await api.get(`/documentos/${cnpj_cpf}`)
            const { documentos } = data
            setDocuments(documentos)
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
        }
    }, [cnpj_cpf])

    useEffect(() => {
        getDocuments()
    }, [getDocuments])

    async function handleSubmitDocument(document: DocumentsType) {
        const files = document.files
        const existsSomeWrongFile = files.some(
            (item) => !item.file || !item.file.name || !item.file.name
        )
        if (existsSomeWrongFile || document.files.length === 0) {
            toast.error('Nenhum arquivo selecionado.')
            return {
                error: true,
            }
        }

        if (files.length !== document.numFilesRequired) {
            toast.error('Por favor, envie todos os arquivos necessários')
            return {
                error: true,
            }
        }
        const fileTypeRegx = /^(image\/(jpeg|jpg|png)|application\/pdf)$/i
        const fileNameRegx = /\.(pdf|jpe?g|png)$/i
        const existsSomeInvalidFile = files.some(
            (item) =>
                !fileTypeRegx.test(item.file.type) ||
                !fileNameRegx.test(item.file.name)
        )
        if (existsSomeInvalidFile) {
            toast.error(
                'Tipo do arquivo inválido. Somente arquivos JPG, JPEG, PNG e PDF são permitidos.'
            )

            return {
                error: true,
            }
        }
        const existsSomeInvalidSizeFile = files.some(
            (item) => item.file.size > 8 * 1024 * 1024
        )
        if (existsSomeInvalidSizeFile) {
            toast.error('Tamanho do arquivo inválido. Tamanho maximo: 8MB.')
            return {
                error: true,
            }
        }
        const formData = new FormData()
        formData.set('documentGroup', document.documentGroup)
        formData.set('cnpj_cpf', cnpj_cpf)

        files.forEach((item) => {
            formData.append('documents', item.file, item.docType)
        })

        try {
            // await fakerAPI(3000)

            await api.post('/documentos', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })

            toast.success('Documento enviado com sucesso!')

            await getDocuments()

            return {
                error: false,
            }
        } catch (error: any) {
            const status = get(error, 'response.status')
            if (status === 400) {
                const messageError = get(error, 'response.data.error', '')
                toast.error(messageError)
            } else {
                toast.error('Ocorreu um erro.')
            }
            return {
                error: true,
            }
        }
    }

    const identificationDocument = useMemo(() => {
        const doc = documents.find(
            (document) => document.grupoDocumento === 'documento-identificacao'
        )
        if (!doc) return null
        return doc
    }, [documents])

    const selfieWithDocument = useMemo(() => {
        const doc = documents.find(
            (document) => document.grupoDocumento === 'selfie-documento'
        )
        if (!doc) return null
        return doc
    }, [documents])

    const cnpjCard = useMemo(() => {
        const doc = documents.find(
            (document) => document.grupoDocumento === 'cartao-cnpj'
        )
        if (!doc) return null
        return doc
    }, [documents])

    const socialContract = useMemo(() => {
        const doc = documents.find(
            (document) => document.grupoDocumento === 'contrato-social'
        )
        if (!doc) return null
        return doc
    }, [documents])

    const addressProof = useMemo(() => {
        const doc = documents.find(
            (document) => document.grupoDocumento === 'comprovante-endereco'
        )
        if (!doc) return null
        return doc
    }, [documents])

    function generateStatus(document: Document | null) {
        if (!document || document.status === 'Pendente') {
            return (
                <span className="p-1 border border-amber-400 text-amber-600 bg-amber-400/20 rounded-md">
                    {document?.status || 'Pendente'}
                </span>
            )
        }

        if (document.status === 'Em análise') {
            return (
                <span className="p-1 border border-slate-400 text-slate-600 bg-slate-400/20 rounded-md">
                    {document.status}
                </span>
            )
        }

        if (document.status === 'Aprovado') {
            return (
                <span className="p-1 border border-blue-400 text-blue-600 bg-blue-400/20 rounded-md">
                    {document.status}
                </span>
            )
        }

        if (document.status === 'Recusado') {
            return (
                <span className="p-1 border border-red-400 text-red-600 bg-red-400/20 rounded-md">
                    {document.status}
                </span>
            )
        }
    }

    return (
        <div>
            {isLoading ? (
                <p></p>
            ) : (
                <>
                    <Header>
                        <div className="title">
                            <h2>Documentos</h2>
                            <p>Atualize os dados bancários da sua empresa</p>
                        </div>
                    </Header>
                    <DocumentContainer>
                        {/* tabela */}
                        <TableContainer>
                            <DocumentTable>
                                <thead>
                                    <tr>
                                        <th>Documento </th>
                                        <th>Status</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            Documento de identificação do
                                            sócio/representante legal
                                        </td>
                                        <td>
                                            {generateStatus(
                                                identificationDocument
                                            )}
                                        </td>
                                        <td>
                                            {(!identificationDocument ||
                                                identificationDocument.status ===
                                                    'Pendente') && (
                                                <button
                                                    onClick={() =>
                                                        setIsDocIdOpen(true)
                                                    }
                                                    className="py-1 px-2 flex items-center gap-x-1 bg-green-600 hover:opacity-90 focus:ring-green-500 focus:ring-offset-green-200 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-md"
                                                >
                                                    Enviar
                                                    <MdOutlineFileUpload className="w-5 h-5" />
                                                </button>
                                            )}
                                            {identificationDocument?.status ===
                                                'Recusado' && (
                                                <button
                                                    onClick={() =>
                                                        setIsDocIdOpen(true)
                                                    }
                                                    className="py-1 px-2 flex items-center gap-x-1 bg-green-600 hover:opacity-90 focus:ring-green-500 focus:ring-offset-green-200 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-md"
                                                >
                                                    Reenviar
                                                    <MdOutlineFileUpload className="w-5 h-5" />
                                                </button>
                                            )}
                                            {(identificationDocument?.status ===
                                                'Aprovado' ||
                                                identificationDocument?.status ===
                                                    'Em análise') && (
                                                <button className="py-1 px-2 inline-flex items-center gap-x-1 bg-blue-600 hover:opacity-90 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md rounded-md">
                                                    Enviado
                                                </button>
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            Selfie segurando documento de
                                            identificação{' '}
                                        </td>
                                        <td>
                                            {generateStatus(selfieWithDocument)}
                                        </td>
                                        <td>
                                            {(!selfieWithDocument ||
                                                selfieWithDocument.status ===
                                                    'Pendente') && (
                                                <button
                                                    onClick={() =>
                                                        setIsSelfieOpen(true)
                                                    }
                                                    className="py-1 px-2 flex items-center gap-x-1 bg-green-600 hover:opacity-90 focus:ring-green-500 focus:ring-offset-green-200 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-md"
                                                >
                                                    Enviar
                                                    <MdOutlineFileUpload className="w-5 h-5" />
                                                </button>
                                            )}
                                            {selfieWithDocument?.status ===
                                                'Recusado' && (
                                                <button
                                                    onClick={() =>
                                                        setIsSelfieOpen(true)
                                                    }
                                                    className="py-1 px-2 flex items-center gap-x-1 bg-green-600 hover:opacity-90 focus:ring-green-500 focus:ring-offset-green-200 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-md"
                                                >
                                                    Reenviar
                                                    <MdOutlineFileUpload className="w-5 h-5" />
                                                </button>
                                            )}
                                            {(selfieWithDocument?.status ===
                                                'Aprovado' ||
                                                selfieWithDocument?.status ===
                                                    'Em análise') && (
                                                <button className="py-1 px-2 inline-flex items-center gap-x-1 bg-blue-600 hover:opacity-90 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md rounded-md">
                                                    Enviado
                                                </button>
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Cartão CNPJ</td>
                                        <td>{generateStatus(cnpjCard)}</td>
                                        <td>
                                            {(!cnpjCard ||
                                                cnpjCard.status ===
                                                    'Pendente') && (
                                                <button
                                                    onClick={() =>
                                                        setIsCNPJCardOpen(true)
                                                    }
                                                    className="py-1 px-2 flex items-center gap-x-1 bg-green-600 hover:opacity-90 focus:ring-green-500 focus:ring-offset-green-200 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-md"
                                                >
                                                    Enviar
                                                    <MdOutlineFileUpload className="w-5 h-5" />
                                                </button>
                                            )}
                                            {cnpjCard?.status ===
                                                'Recusado' && (
                                                <button
                                                    onClick={() =>
                                                        setIsCNPJCardOpen(true)
                                                    }
                                                    className="py-1 px-2 flex items-center gap-x-1 bg-green-600 hover:opacity-90 focus:ring-green-500 focus:ring-offset-green-200 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-md"
                                                >
                                                    Reenviar
                                                    <MdOutlineFileUpload className="w-5 h-5" />
                                                </button>
                                            )}
                                            {(cnpjCard?.status === 'Aprovado' ||
                                                cnpjCard?.status ===
                                                    'Em análise') && (
                                                <button className="py-1 px-2 inline-flex items-center gap-x-1 bg-blue-600 hover:opacity-90 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md rounded-md">
                                                    Enviado
                                                </button>
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            Copia do contrato social autenticada
                                        </td>
                                        <td>
                                            {generateStatus(socialContract)}
                                        </td>
                                        <td>
                                            {(!socialContract ||
                                                socialContract.status ===
                                                    'Pendente') && (
                                                <button
                                                    onClick={() =>
                                                        setIsSocialContractOpen(
                                                            true
                                                        )
                                                    }
                                                    className="py-1 px-2 flex items-center gap-x-1 bg-green-600 hover:opacity-90 focus:ring-green-500 focus:ring-offset-green-200 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-md"
                                                >
                                                    Enviar
                                                    <MdOutlineFileUpload className="w-5 h-5" />
                                                </button>
                                            )}
                                            {socialContract?.status ===
                                                'Recusado' && (
                                                <button
                                                    onClick={() =>
                                                        setIsSocialContractOpen(
                                                            true
                                                        )
                                                    }
                                                    className="py-1 px-2 flex items-center gap-x-1 bg-green-600 hover:opacity-90 focus:ring-green-500 focus:ring-offset-green-200 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-md"
                                                >
                                                    Reenviar
                                                    <MdOutlineFileUpload className="w-5 h-5" />
                                                </button>
                                            )}
                                            {(socialContract?.status ===
                                                'Aprovado' ||
                                                socialContract?.status ===
                                                    'Em análise') && (
                                                <button className="py-1 px-2 inline-flex items-center gap-x-1 bg-blue-600 hover:opacity-90 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md rounded-md">
                                                    Enviado
                                                </button>
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Comprovante de endereço</td>
                                        <td>{generateStatus(addressProof)}</td>
                                        <td>
                                            {(!addressProof ||
                                                addressProof.status ===
                                                    'Pendente') && (
                                                <button
                                                    onClick={() =>
                                                        setIsAddressProofOpen(
                                                            true
                                                        )
                                                    }
                                                    className="py-1 px-2 flex items-center gap-x-1 bg-green-600 hover:opacity-90 focus:ring-green-500 focus:ring-offset-green-200 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-md"
                                                >
                                                    Enviar
                                                    <MdOutlineFileUpload className="w-5 h-5" />
                                                </button>
                                            )}
                                            {addressProof?.status ===
                                                'Recusado' && (
                                                <button
                                                    onClick={() =>
                                                        setIsAddressProofOpen(
                                                            true
                                                        )
                                                    }
                                                    className="py-1 px-2 flex items-center gap-x-1 bg-green-600 hover:opacity-90 focus:ring-green-500 focus:ring-offset-green-200 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-md"
                                                >
                                                    Reenviar
                                                    <MdOutlineFileUpload className="w-5 h-5" />
                                                </button>
                                            )}
                                            {(addressProof?.status ===
                                                'Aprovado' ||
                                                addressProof?.status ===
                                                    'Em análise') && (
                                                <button className="py-1 px-2 inline-flex items-center gap-x-1 bg-blue-600 hover:opacity-90 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md rounded-md">
                                                    Enviado
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                                {/* <tbody>{renderTableRowUR()}</tbody> */}
                            </DocumentTable>
                        </TableContainer>
                        {/* Aviso */}
                        <div className="border-b pb-6 border-[#d3d3d3] mt-6">
                            <div className="flex items-center gap-4  border-amber-400  bg-amber-300/80 rounded-md p-4 shadow-sm">
                                <FiAlertCircle className="h-8 w-8 text-gray-700" />
                                <p className="text-gray-700 font-medium text-lg tracking-tight">
                                    <span className="font-semibold text-gray-800">
                                        IMPORTANTE:
                                    </span>{' '}
                                    Os arquivos deverão estar no formato PDF ou
                                    Imagem (jpeg, jpg ou png) e deverão ter no
                                    máximo 8MB. Envie para análise somente
                                    quando estiver certo que os documentos estão
                                    corretos.
                                </p>
                            </div>
                        </div>
                        {/* Messagem */}
                        <div className="mt-6">
                            <p className="text-gray-500 tracking-tight font-medium">
                                Ao enviar os arquivos você concorda
                                expressamente com o uso dos documentos para
                                completar o seu cadastro e possibilitar o pleno
                                fornecimento de nossos serviços, estando ciente
                                do armazenamento e compartilhamento das suas
                                informações nos termos da nossa Política de
                                Privacidade.
                            </p>
                        </div>
                    </DocumentContainer>
                    <DocumentsModal
                        isOpen={isDocIdOpen}
                        setIsOpen={setIsDocIdOpen}
                    >
                        <IdentificationDocument
                            handleSubmit={handleSubmitDocument}
                            setIsOpen={setIsDocIdOpen}
                        />
                    </DocumentsModal>

                    <DocumentsModal
                        isOpen={isSelfieOpen}
                        setIsOpen={setIsSelfieOpen}
                    >
                        <SelfieWithDocument
                            handleSubmit={handleSubmitDocument}
                            setIsOpen={setIsSelfieOpen}
                        />
                    </DocumentsModal>

                    <DocumentsModal
                        isOpen={isCNPJCardOpen}
                        setIsOpen={setIsCNPJCardOpen}
                    >
                        <CNPJCard
                            handleSubmit={handleSubmitDocument}
                            setIsOpen={setIsCNPJCardOpen}
                        />
                    </DocumentsModal>

                    <DocumentsModal
                        isOpen={isSocialContractOpen}
                        setIsOpen={setIsSocialContractOpen}
                    >
                        <SocialContract
                            handleSubmit={handleSubmitDocument}
                            setIsOpen={setIsSocialContractOpen}
                        />
                    </DocumentsModal>

                    <DocumentsModal
                        isOpen={isAddressProofOpen}
                        setIsOpen={setIsAddressProofOpen}
                    >
                        <AddressProof
                            handleSubmit={handleSubmitDocument}
                            setIsOpen={setIsAddressProofOpen}
                        />
                    </DocumentsModal>
                </>
            )}
        </div>
    )
}

export default Documentos
